import { render, staticRenderFns } from "./plans-navigation.vue?vue&type=template&id=1897e62d&scoped=true&"
import script from "./plans-navigation.vue?vue&type=script&lang=ts&"
export * from "./plans-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./plans-navigation.vue?vue&type=style&index=0&id=1897e62d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1897e62d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VSpacer})
